// Clears any text selection. If the annotation button is opened,
// this will also trigger it to disappear. This is useful for cases
// where the button persists when clicking on interactive elements.
const clearTextSelection = () => {
  document.getSelection().removeAllRanges();
};

export default clearTextSelection;
